<template>
  <div class="p-header">
    <div class="top-nav-wrap">
      <div class="right-wrap">
        <div class="logo-box box-flex">
          <div class="logo" @click="toLink('/home')">
            <img v-if="logo" style="height: 100%; pointer-events: none" :src="logo" fit="contain" alt />
          </div>
        </div>
        <div class="action-wrap">
          <div class="top-nav-wrap" v-if="topNavs">
            <div
              class="topnav-item"
              v-for="(item, index) in topNavs"
              :key="item.name"
              @click="handleTopNav(item, `101_30_0_${index}`)"
            >
              <img
                class="topnav-item-icon"
                v-if="item.Languages.icon"
                :src="$utils.returnImgUrl(item.Languages.icon)"
                alt=""
              />
              <div
                class="topnav-item-name"
                v-exposure="{ eid: `101_30_0_${index}`, jump_vlaue: item.jump }"
                :data-id="`101_30_0_${index}`"
              >
                {{ item.Languages.name }}
              </div>
            </div>
          </div>
          <div class="login-btn" v-if="!isLogin">
            <emailIcon />
            <div @click="clickSearch" class="search-icon" v-exposure="{ eid: `101_0_0_128` }" :data-id="`101_0_0_128`">
              <img class="icon" src="@/assets/user/search.png" alt="" />
            </div>
            <el-button
              class="lgoin-button"
              v-for="(item, i) in menuItems"
              :class="'lgoin-button' + item.value"
              :key="i"
              @click="clickFun(item.value, item.eid)"
              size="small"
              v-exposure="{ eid: item.eid }"
              :data-id="item.eid"
              >{{ item.title }}</el-button
            >
            <el-dropdown trigger="click" placement="bottom-start" style="margin-left: 10px" @command="changeFun">
              <img class="cur-lang-icon-new" :src="getlangIcon" alt />
              <el-dropdown-menu slot="dropdown" :style="computeStyle">
                <el-dropdown-item v-for="item in locales" :key="item.locale" :command="item.locale">
                  <div class="lang-row-wrap">
                    <img :src="item.icon" class="language-icon" alt />
                    <span class="language-title">{{ item.title }}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="head-user-info box-flex" v-else>
            <emailIcon />
            <div @click="clickSearch" class="search-icon" v-exposure="{ eid: `101_0_0_128` }" :data-id="`101_0_0_128`">
              <img class="icon" src="@/assets/user/search.png" alt="" />
            </div>
            <div id="vStep" class="godVip-box" v-exposure="{ eid: `101_0_0_129` }" :data-id="`101_0_0_129`">
              <!-- <label
                v-if="UserCoins.length === 1"
                class="el-dropdown-link"
                style="position: relative"
                @click="goWalletDetail"
              >
                <img :src="$utils.returnImgUrl(curCoin.coinIcon)" alt />
                <span style="margin-right: 2px">{{ curCoin.symbol }}</span>
                <span v-if="inGame">{{ $t("Datalang.HomePage_TITLE_ingaming") }}</span>
                <span v-else>{{ divideSymbol(curCoin.allChips, curCoin.accuracy) }}</span>
              </label> -->
              <el-dropdown
                @command="handleCheck"
                ref="messageDrop"
                @visible-change="visibleChange"
                :hide-on-click="true"
                @click.native="dropdown"
                trigger="click"
                :disabled="
                  inGame ||
                  getPacketConfig.withdrawMode === 'WITHDRAW_MODE_LIMIT' ||
                  getPacketConfig.withdrawMode === 'WITHDRAW_MODE_CLOSE'
                "
              >
                <!-- 单一货币展示 -->
                <div v-if="coinStyle === 2" class="el-dropdown-link el-dropdown-link1" style="position: relative">
                  <div>
                    <div class="flex">
                      <img :src="$utils.returnImgUrl(curCoin.coinIcon)" alt />
                      <span style="margin-right: 2px">{{ curCoin.symbol }}</span>
                      <span v-if="inGame">（{{ $t("Datalang.HomePage_TITLE_ingaming") }}）</span>
                      <span v-else>{{ divideSymbol(curCoin.chips, curCoin.accuracy) }}</span>
                    </div>
                    <div v-if="Number(curCoin.experience) > 0" class="flex">
                      <img :src="$utils.returnImgUrl(curCoin.freeIcon || curCoin.coinIcon)" alt />
                      <span style="margin-right: 2px">{{ curCoin.freeSymbol || curCoin.symbol }}</span>
                      <span v-if="inGame">（{{ $t("Datalang.HomePage_TITLE_ingaming") }}）</span>
                      <span v-else>{{ divideSymbol(curCoin.experience, curCoin.accuracy) }}</span>
                    </div>
                  </div>
                  <i
                    v-if="
                      getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_LIMIT' &&
                      getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_CLOSE'
                    "
                    class="el-icon-arrow-down"
                    :class="{
                      'is-reverse': boxVisible,
                    }"
                    style="margin-left: 5px; font-weight: bold"
                  ></i>
                </div>
                <!-- 多货币 -->
                <label v-else class="el-dropdown-link" style="position: relative">
                  <img :src="$utils.returnImgUrl(curCoin.coinIcon)" alt />
                  <span style="margin-right: 2px">{{ curCoin.symbol }}</span>
                  <span v-if="inGame">（{{ $t("Datalang.HomePage_TITLE_ingaming") }}）</span>
                  <span v-else>{{ divideSymbol(curCoin.allChips, curCoin.accuracy) }}</span>
                  <i
                    v-if="
                      getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_LIMIT' &&
                      getPacketConfig.withdrawMode !== 'WITHDRAW_MODE_CLOSE'
                    "
                    class="el-icon-arrow-down"
                    :class="{
                      'is-reverse': boxVisible,
                    }"
                    style="margin-left: 5px; font-weight: bold"
                  ></i>
                </label>
                <el-dropdown-menu slot="dropdown" :style="computeStyle2" class="wallet_list_header">
                  <template v-if="coinStyle === 2">
                    <el-dropdown-item class="qbMode">
                      <div class="qbModeMain">
                        <div class="qbModeMainTop">
                          <div>{{ $t("Datalang.home_deposit_balance") }}</div>
                          <span class="el-icon-question" @click.stop="onShowInfoModal(3, 1)"></span>
                        </div>
                        <div class="qbModeMainCon">
                          <div class="amount">{{ UserCoins[0]?.symbol + ' ' + divideSymbol(UserCoins[0]?.chips) }}</div>
                          <div class="qbModeMainConRight">
                            <div></div>
                            <div class="btn" @click.stop="goWithdraw(1)" align="center">{{ $t("Datalang.Menu_BTM_withdraw") }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="qbModeMain mt10" v-if="UserCoins[0]?.experience > 0">
                        <div class="qbModeMainTop">
                          <div>{{ $t("Datalang.home_exprience") }}</div>
                          <span class="el-icon-question" @click.stop="onShowInfoModal(3, 2)"></span>
                        </div>
                        <div class="qbModeMainCon">
                          <div class="amount">{{ (UserCoins[0]?.freeSymbol || UserCoins[0]?.symbol) + ' ' + divideSymbol(UserCoins[0]?.experience) }}</div>
                          <div class="qbModeMainConRight">
                            <div></div>
                            <div class="btn" @click.stop="goWithdraw(2)" align="center">{{ getBtnTxt() }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="qbModeMain mt10" v-if="hasCommissionWallet">
                        <div class="qbModeMainTop">
                          <div>{{ $t("Datalang.Home_Commission_Balance5") }}</div>
                          <span class="el-icon-question" @click.stop="onShowInfoModal(3, 3)"></span>
                        </div>
                        <div class="qbModeMainCon">
                          <div class="amount">{{ UserCoins[0]?.symbol + ' ' + divideSymbol(UserCoins[0]?.commission) }}</div>
                          <div class="qbModeMainConRight">
                            <div class="btn mr10" @click.stop="goHandleChange(UserCoins[0]?.coinCode)" align="center">{{ $t("Datalang.Transfer_to_ACCOUNT") }}</div>
                            <div class="btn" @click.stop="goWithdraw(3)" align="center">{{ $t("Datalang.Menu_BTM_withdraw") }}</div>
                          </div>
                        </div>
                      </div>
                    </el-dropdown-item>
                  </template>
                  <template v-else>
                    <el-dropdown-item class="qbHeaer">
                      <div align="left">
                        {{ $t("Datalang.Menu_BTM_mywallet") }}
                        <span v-if="rateList.length > 0" class="el-icon-question" @click="onShowInfoModal(1)"></span>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-for="(item, i) in UserCoins"
                      :command="item.coinCode"
                      :key="i"
                      class="qbItem"
                      :disabled="curCoin.coinCode === item.coinCode"
                    >
                      <div class="qbDiv">
                        <img :src="$utils.returnImgUrl(item.coinIcon)" alt />
                        <span v-if="item.isExperienceCoinCode">{{ $t("Datalang.home_exprience") }}&nbsp;&nbsp;</span>
                        <span v-else>{{ item.coinCode }}&nbsp;&nbsp;</span>
                        <div class="chips">
                          <div class="symbol_coin">
                            {{ divideSymbol(item.isExperienceCoinCode ? item.experience : item.chips) }}
                          </div>
                        </div>
                      </div>
                      <div class="experienceDiv" v-if="item.isExperienceCoinCode">
                        <ExperienceWallet :experienceObj="item" />
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item class="qbFooter" :disabled="inGame">
                      <span
                        :class="`walletBtn ${inGame ? 'disable_btn' : ''} ${isFirst ? 'first' : ''}`"
                        @click="toWallet"
                        align="center"
                        >{{ $t("Datalang.Menu_BTM_mywallet") }}</span
                      >
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 自定义提示 -->
              <!-- <div v-if="isShowTip" class="dropdown-tip">{{ `${curCoin.freeSymbol || curCoin.symbol} ${$t("Datalang.home_withdraw_now")}` }}<span class="dropdown-tip-arrow"></span></div> -->
            </div>
            <el-button type="primy" class="recharge" style="margin-left: 16px" @click="showCharge" size="small">
              {{ $t("Datalang.newly_deposit9") }}
            </el-button>
            <el-button
              slot="reference"
              type="primy"
              class="withdraw"
              style="margin-left: 16px"
              @click="showExchange"
              size="small"
            >
              {{ $t("Datalang.newly_withdraw5") }}
              <div class="firstWithdrawTis-wrap" @click="clickBubble" v-if="showFirstWithdrawTis">
                <div class="text1">{{ firstWithdrawText1 }}</div>
                <div class="bg"></div>
                <div class="triangle"></div>
              </div>
            </el-button>
          </div>

          <template v-if="isLogin">
            <div class="user-wrap">
              <el-dropdown
                trigger="click"
                placement="bottom-start"
                :style="`height: ${$px2rem(46)}; line-height: ${$px2rem(46)}; margin-left: ${$px2rem(10)}`"
                @command="handleCommand"
              >
                <span class="avatarimg">
                  <el-avatar
                    :size="38"
                    style="margin-top: 3px"
                    :src="$utils.avatarUrl()"
                    fit="cover"
                    v-exposure="{ eid: `101_0_0_133` }"
                    :data-id="`101_0_0_133`"
                  ></el-avatar>
                </span>
                <el-dropdown-menu slot="dropdown" class="dropdown-box">
                  <el-dropdown-item v-for="(item, i) in dropdownMenu" :key="i" :command="item">
                    <img class="icon" :src="item.icon" alt />
                    <span class="title">{{ item.title }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="account_info">
                <div class="account_info-name">{{ userData.nickname }}</div>
                <div class="account_vip">
                  <img class="p_vip" :src="p_vip" alt />
                  <span>VIP{{ userData.level }}</span>
                </div>
              </div>
            </div>
          </template>

          <el-dropdown
            v-if="isLogin"
            trigger="click"
            placement="bottom-start"
            style="margin-left: 10px"
            @command="changeFun"
          >
            <img class="cur-lang-icon-new" :src="getlangIcon" alt />
            <el-dropdown-menu slot="dropdown" :style="computeStyle">
              <el-dropdown-item v-for="item in locales" :key="item.locale" :command="item.locale">
                <div class="lang-row-wrap">
                  <img :src="item.icon" class="language-icon" alt />
                  <span class="language-title">{{ item.title }}</span>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <PopupDialog
          ref="PopupDialog"
          width="500px"
          :dataOpt="{
            title: getTitle(),
          }"
          :show.sync="PopupWindowShow"
          @close="closeFun"
        >
          <template #center>
            <div class="modal-info">
              <div v-if="infoType === 1">
                <p>1. {{ $t("Datalang.Wallet_TEXT_circulationcurrenc") }}</p>
                <template v-if="rateList.length">
                  <div v-for="item in rateList" :key="item.id">
                    1{{ item.fromCoin }} ≈ {{ item.rate }} {{ item.toCoin }}
                  </div>
                </template>
                <p>2. {{ $t("Datalang.Wallet_TEXT_defaultwallet") }}</p>
              </div>
              <div v-if="infoType === 2">
                <p>{{ $t("Datalang.home_withdrawable") }}</p>
              </div>
              <div v-if="infoType === 3">
                <p>{{ getTxt() }}</p>
              </div>
              <div class="btn-content">
                <el-button round type="primary" @click="closeFun">{{ $t("Datalang.Withdrawl_TIP_getit") }}</el-button>
              </div>
            </div>
          </template>
        </PopupDialog>
      </div>
    </div>

    <div class="menu-main">
      <div class="menu-wrap">
        <!-- <div class="logo-box box-flex">
          <div class="logo" @click="toLink('/home')">
            <img v-if="logo" style="height: 100%; pointer-events: none" :src="logo" fit="contain" alt />
          </div>
        </div> -->
        <el-menu
          v-if="topNavsIsList"
          :class="['nav-menu-list']"
          ref="menu"
          @select="handleSelect($event, 'menu')"
          mode="horizontal"
        >
          <div class="grid-box grid-wrap menu-inner" ref="menuWrap">
            <div
              :class="['grid-item', 'nav-row-warp', `type${item.menuType}`, `hasIconType${item.iconType}`]"
              v-for="(item, i) in pNavs"
              :key="item.sid"
              ref="menuItem"
            >
              <el-submenu
                :class="['sub-item-wrap', 'nav-row', `nav-row${item.iconType}`]"
                v-if="item.childMenu && item.childMenu.length"
                :index="String(item.sid)"
              >
                <div slot="title">
                  <span
                    @click="handleSelect(item.sid, i)"
                    :class="['name', `name${item.iconType}`, openMenu[item.sid] ? 'titelAcl' : '']"
                    slot="title"
                    v-exposure="{ eid: item.eid, jump_vlaue: item?.jump || {} }"
                    :data-id="item.eid"
                  >
                    {{ langName(item.language) }}
                  </span>
                </div>
                <div class="grid-box">
                  <el-menu-item
                    :class="[
                      'grid-item',
                      'nav-row',
                      'nav-row-sub',
                      `nav-row${chil.iconType}`,
                      `type${chil.menuType}`,
                      `hasIconType${chil.iconType}`,
                    ]"
                    v-for="chil in item.childMenu"
                    :key="chil.sid"
                    :index="String(chil.sid)"
                  >
                    <div
                      :class="['nav-icon-wrap', `iconType${chil.iconType}`, selectMenu === chil.sid ? 'active' : '']"
                    >
                      <img class="nav-icon unselected" :src="getIconMap(chil.language, 1)" alt="" />
                      <img class="nav-icon selected" :src="getIconMap(chil.language, 2)" alt="" />
                      <img class="nav-icon iconSmall" :src="getIconMap(item.language, 3)" alt="" />
                    </div>
                    <span
                      :class="['name', `name${chil.iconType}`, selectMenu === chil.sid ? 'titelAcl' : '']"
                      slot="title"
                      v-exposure="{ eid: chil.eid, jump_vlaue: chil?.jump || {} }"
                      :data-id="chil.eid"
                    >
                      {{ langName(chil.language) }}
                    </span>
                  </el-menu-item>
                </div>
              </el-submenu>
              <el-menu-item :class="['nav-row', `nav-row${item.iconType}`]" v-else :index="String(item.sid)">
                <span
                  :class="['name', `name${item.iconType}`, selectMenu === item.sid ? 'titelAcl' : '']"
                  slot="title"
                  v-exposure="{ eid: item.eid, jump_vlaue: item?.jump || {} }"
                  :data-id="item.eid"
                >
                  {{ langName(item.language) }}
                </span>
                <div class="redPoint" v-if="havePoint(item)"></div>
              </el-menu-item>
            </div>
          </div>
        </el-menu>

        <div v-if="topNavsIsImageList" ref="menuWrap" class="menu-inner imageList">
          <div
            class="menu-item"
            ref="menuItem"
            v-for="(item, i) in pNavs"
            :key="item.sid"
            @mouseleave="showMask = false"
            @mouseenter="() => item.childMenu && item.childMenu.length && (showMask = true)"
            @click="handleSelect(item.sid, i)"
          >
            <div
              class="menu-item-name"
              :class="{
                titelAcl: selectMenu === item.sid,
              }"
              v-exposure="{ eid: item.eid, jump_vlaue: item?.jump || {} }"
              :data-id="item.eid"
            >
              <span>{{ langName(item.language) }}</span>
              <div class="redPoint" v-if="havePoint(item)"></div>
            </div>
            <template v-if="item.childMenu && item.childMenu.length">
              <div
                class="menu-item-sub"
                :class="{
                  isInTelegramWebApp: isTgFullscreen,
                }"
              >
                <div class="menu-item-wrap-bg">
                  <div class="menu-item-wrap">
                    <div
                      class="sub-item"
                      v-for="chil in item.childMenu"
                      :key="String(chil.sid)"
                      @click="handleSelect(chil.sid, i)"
                    >
                      <div class="sub-item_thumb">
                        <img class="sub-item-icon" :src="getIconMap(chil.language, 2)" alt="" />
                        <!-- <div class="sub-item-name">{{ langName(chil.language) }}</div> -->
                      </div>
                      <div
                        class="sub-item_play"
                        v-exposure="{ eid: chil.eid, jump_vlaue: chil?.jump || {} }"
                        :data-id="chil.eid"
                      >
                        <el-button type="primary" class="btn">Betting</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- <div
              class="menu-mask"
              :class="{
                show: showMask,
                isInTelegramWebApp: isInTelegramWebApp,
              }"
            ></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import p_vip from "@/assets/user/p_vip.png";

import dimg4 from "@/assets/user/shezhi_caijin.png";
import dimg14 from "@/assets/user/shezhi_yongjin.png";
import dimg1 from "@/assets/user/shezhi_chongzhi.png";
import dimg6 from "@/assets/user/shezhi_gerenziliao.png";
import dimg9 from "@/assets/user/shezhi_huodong.png";
import dimg7 from "@/assets/user/shezhi_jiaoyijilu.png";
import dimg3 from "@/assets/user/shezhi_qianbao.png";
import dimg2 from "@/assets/user/shezhi_tixian.png";
import dimg10 from "@/assets/user/shezhi_touzhu.png";
import dimg12 from "@/assets/user/shezhi_tuichu.png";
import dimg5 from "@/assets/user/shezhi_vip.png";
import dimg11 from "@/assets/user/shezhi_xiaoxi.png";
import dimg8 from "@/assets/user/shezhi_yaoqing.png";
import celanbtn from "@/assets/home/celan_btn.png";
import zengli from "@/assets/user/shezhi_zengli.png";
import { selectWallet } from "@/lobby_common/api/user_gen";
import { killPlayerUser } from "@/lobby_common/api/game_gen";
import { getCoinExchangeRateData } from "@/lobby_common/utils/utils.js";
import { resMenuListC as resMenuList } from "@/lobby_common/api/cacheApi";
// import Jb from "@/assets/img/jb.png";
// import UserIcon from "@/assets/img/txk.png";
import PopupDialog from "@/components/PopupDialog";
import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import { divideAccuracy, divideSymbol, isGame, formatLang } from "@/lobby_common/utils/utils.js";
import { debounce } from "@/lobby_common/utils/index.js";
import { mapActions, mapGetters } from "vuex";
import { setLocale } from "@/lobby_common/locale";
import { getAnyZoneTime } from "@/lobby_common/utils/date";
import { goJoinEvent, getTxtFun, goWithdrawFun, getBtnTxtFun, goHandleChangeFun } from "@/lobby_common/utils/utils.js";
import { updateUserLanguage } from "@/lobby_common/api/user_gen.js";
import { cacheKeys } from "@/lobby_common/utils/commonEnum.js";
import { bigAdd } from "@/lobby_common/utils/big.js";
import ExperienceWallet from "@/components/experienceWallet/index.vue";
import emailIcon from "@/lobby_common/mixins_components/emailIcon/index.vue";
import { clearAllDB } from '@/lobby_common/utils/jsonCache.js'
export default {
  name: "p-header",
  mixins: [hideGmae],
  components: { PopupDialog, ExperienceWallet, emailIcon },
  data() {
    return {
      bigAdd,
      boxVisible: false,
      formatLang,
      dimg1,
      dimg2,
      dimg3,
      dimg4,
      dimg14,
      dimg5,
      dimg6,
      dimg7,
      dimg8,
      dimg9,
      dimg10,
      dimg11,
      dimg12,
      celanbtn,
      zengli,
      killPlayerUser,
      sportsBrand: {
        brand_id: 14,
      },
      // Jb,
      // UserIcon,
      divideAccuracy,
      divideSymbol,
      listData: [],
      // curCoin: {},
      obj: {},
      UserCoins: [],
      isGame: isGame,
      PopupWindowShow: false,
      // rateList: [],
      isFirst: false,
      timer: null,
      bTime: [],
      curNum: undefined,
      p_vip,
      setLocale,
      inGame: false,
      isApi: false,
      pNavs: [],
      selectMenu: "",
      curItem: {},
      openMenu: {},
      cacheKeys,
      showMask: false,
      infoType: 1,
      walletTypeTxt: 1,
      // rateLoading: false,
      // coinExchangeRate: [],
      currentIndex: 0,
    };
  },
  watch: {
    "$route.path": {
      handler: function () {
        this.inGame = !!this.isGame();
      },
      deep: true,
      immediate: true,
    },
    getUserCoins: {
      handler: function () {
        this.handeleUserCoins();
      },
      deep: true,
      immediate: true,
    },
    isLogin: {
      handler: function () {
        this.getUserFirstWithdrawHintFun(this.getPacketConfig.coinCode);
      },
      immediate: true,
    },
  },
  async created() {
    const that = this;
    // that.getGamelistFun();
    // that.getTime();
    await this.getMenu();
  },
  computed: {
    hasCommissionWallet() {
      const obj = this.$store.getters.getPacketConfig?.appConfig || {};
      const walletType = obj.wallets || [];
      return walletType.includes("COMMISSION_WALLET");
    },
    computeStyle() {
      return `max-height: 500px; padding-bottom: ${this.isMobile ? "8px" : "22px"};overflow: auto`;
    },
    computeStyle2() {
      if (this.hasExperienceWallet) {
        return `max-height: 500px; padding-bottom:9px;overflow: auto`;
      }
      return `max-height: 500px; padding-bottom:22px;overflow: auto`;
    },
    hidGift() {
      const userInfo = this.$store.getters.user || {};
      const giftInfo = this.$store.getters.getPacketConfig?.appConfig?.gift || {};
      let flag = true;
      if (giftInfo.status !== "ROW_STATUS_ENABLE") {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    topNavigationTemplate() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate || {};
    },
    coinStyle() {
      return Number(this.topNavigationTemplate.coinStyle)
    },
    topNavigation() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.pc || {};
    },
    topNavs() {
      if (this.topNavigation && this.topNavigation.center === 2 && this.topNavigation.functions) {
        return this.topNavigation.functions || [];
      }
      return null;
    },
    // 下拉列表
    topNavsIsList() {
      return this.topNavigation?.menuPosition === 4;
    },
    // 下拉大图
    topNavsIsImageList() {
      return this.topNavigation?.menuPosition === 3;
    },
    firstWithdrawHint() {
      return this.$store.getters.getFirstWithdrawHint || {};
    },
    firstWithdrawText1() {
      // vip激活 首提text
      const str =
        this.getPacketConfig.symbol +
        divideAccuracy(this.firstWithdrawHint.firstWithdrawAmount, this.getPacketConfig.accuracy);
      return this.formatLang(this.$t("Datalang.newly_ten_withdraw"), [str]);
    },
    // 开启首提并满足条件
    showFirstWithdrawTis() {
      const data = this.firstWithdrawHint;
      return (
        data.isFirstWithdraw === "STATUS_BOOL_TRUE" &&
        data.isSatisfy === "STATUS_BOOL_TRUE" &&
        Number(data.firstWithdrawAmount) &&
        !this.userData.isWithdraw &&
        !data.bubble
      );
    },
    userInfo() {
      return JSON.parse(JSON.stringify(this.$store.getters.user));
    },
    defaultCoinCode() {
      return this.userInfo.coinCode;
    },
    locales() {
      return this.$store.getters.getLocalesList;
    },
    getUserCoins() {
      return this.$store.getters.getUserCoins;
    },
    curCoin() {
      return this.$store.getters.getCurCoin;
    },
    rateList() {
      return this.$store.getters.getRateList || [];
    },
    coinExchangeRate() {
      return this.$store.getters.getCoinExchangeRate || [];
    },
    rateLoading() {
      return this.$store.getters.getRateLoading;
    },
    getlangIcon() {
      const arr =
        this.locales.filter((v) => {
          return v.locale === this.$store.getters.getLang;
        }) || [];
      // console.log(arr);
      return arr[0] ? arr[0].icon : "";
    },
    getData() {
      return this.$store.getters.getData;
    },
    inCasino() {
      const route = this.$route;
      const ret = ["/other/"].some((f) => route.path.includes(f));
      return !ret;
    },
    isPayNum() {
      const route = this.$route;
      const ret = ["/other/", "/games/", "/payGame/"].some((f) => route.path.includes(f));
      // const text = ret && Number(this.userData?.chips) <= 0;
      return ret ? `(${this.$t("Datalang.HomePage_TITLE_ingaming")})` : divideAccuracy(this.userData?.chips);
    },
    isTy() {
      return this.listData.find((e) => e.gameGroupSid === 115000101);
    },
    coinSymbol() {
      return this.$store.getters.user?.coin_symbol;
    },
    logo() {
      return this.$utils.returnImgUrl(this.$store.getters.getPacketConfig?.site?.indexLogo);
    },
    getPacketConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    popFullscreen() {
      return this.$store.getters.getFullscreen;
    },
    isLogin() {
      return this.$store.getters.login;
    },
    userData() {
      return this.$store.getters.user;
    },
    activityshowdata() {
      return this.$store.getters.activityshow;
    },
    menuItems() {
      const items = [
        {
          title: this.$t("Datalang.promotion_TITLE_Login"),
          type: "text",
          value: 0,
          eid: `101_0_0_142`,
        },
        {
          title: this.$t("Datalang.promotion_TITLE_Register"),
          type: "primary",
          value: 1,
          eid: `101_0_0_143`,
        },
      ];
      return items;
    },
    dropdownMenu() {
      let items = [
        {
          title: this.$t("Datalang.Menu_BTM_recharge"),
          route: "Charge",
          type: "chargeExchange",
          icon: this.dimg1,
          id: 10020017,
        },
        {
          title: this.$t("Datalang.Menu_BTM_withdraw"),
          hide: this.getPacketConfig.withdrawMode === "WITHDRAW_MODE_CLOSE",
          route: "Exchange",
          type: "Exchange",
          icon: this.dimg2,
          id: 10020015,
        },
        {
          title: this.$t("Datalang.Menu_BTM_mywallet"),
          hide:
            this.getPacketConfig.withdrawMode === "WITHDRAW_MODE_LIMIT" ||
            this.getPacketConfig.withdrawMode === "WITHDRAW_MODE_CLOSE",
          route: "/user/wallet",
          type: "router",
          icon: this.dimg3,
        },
        {
          title: this.$t("Datalang.Menu_BTM_VIPcenter"),
          route: "/user/vip",
          type: "router",
          icon: this.dimg5,
          id: 10020005,
        },
        {
          title: this.$t("Datalang.Menu_BTM_playerinfo"),
          route: "/user",
          type: "router",
          icon: this.dimg6,
          id: 11060001,
        },
        {
          title: this.$t("Datalang.Menu_BTM_tranctionrecord"),
          route: "/user/walletRecord",
          type: "router",
          icon: this.dimg7,
        }, // 新  交易记录
        {
          title: this.$t("Datalang.Menu_BTM_intivefirend"),
          // hide: this.$store.getters.getPacketConfig?.packet_config?.promote_method === 2,
          route: "/user/distribution",
          type: "router",
          icon: this.dimg8,
        },
        {
          title: this.$t("Datalang.newly_bonus"),
          route: "/events?tab=1",
          type: "router",
          icon: this.dimg9,
          id: 10020009,
        },
        // {
        //   title: this.$t("Datalang.Menu_BTM_bettingrecord"),
        //   route: "/user/gameRecord",
        //   icon: this.dimg10,
        //   type: "router",
        // }, // 新  投注记录
        {
          title: this.$t("Datalang.Menu_BTM_messagecenter"),
          route: "/user/notice",
          type: "router",
          icon: this.dimg11,
        }, // 新  消息中心
        {
          icon: this.zengli,
          title: this.$t("Datalang.home_Gift"),
          route: "/user/givingGift",
          type: "router",
          hide: this.hidGift,
        },
        {
          title: this.$t("Datalang.Menu_BTM_logout"),
          route: "signOut",
          type: "signOut",
          icon: this.dimg12,
          id: 11060011,
          hide: this.isTgApp,
        },
      ];

      items = items.filter((item) => item.hide !== true);

      return items;
    },
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    getAppConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    isNewWithdrawMode() {
      let withdrawMode = this.getAppConfig.withdrawMode
      return withdrawMode === 'WITHDRAW_MODE_FREE_GOLD'
    },
    isShowTip() {
      let promptFreeGoldWithdraw = this.getAppConfig.promptFreeGoldWithdraw ? Number(this.getAppConfig.promptFreeGoldWithdraw) : 0
      return this.isNewWithdrawMode && promptFreeGoldWithdraw !== 0 && Number(this.curCoin.experience) > promptFreeGoldWithdraw
    },
    // 是否有体验彩金钱包
    hasExperienceWallet() {
      return this.getAppConfig?.wallets?.includes("EXPERIENCE_WALLET") || false;
    },
    ...mapGetters(["menuIsShow", "getIsMobile", "sidebarWidth"]),
  },
  mounted() {},
  methods: {
    // 是否有小红点
    havePoint(obj) {
      document.querySelector(".x1i10hfl.x1qjc9v5.xjbqb8w.xjqpnuy.xa49m3k.xqeqjp1.x2hbi6w.x13fuv20.xu3j5b3");
      const allPoint = this.$store.getters.getAllPoint;
      const jump = obj.jump || {};
      // 开关是否开启
      const isOpen = this.$store?.getters?.getPacketConfig?.packetInfo?.baseInfo?.userOnboarding === "STATUS_BOOL_TRUE";
      return isOpen && allPoint.includes(jump.functionType);
    },
    getIconMap(obj = {}, flag = 1) {
      const unSelectSrc = this.$utils.returnImgUrl(obj.iconUnselected);
      const selectSrc = this.$utils.returnImgUrl(obj.icon);
      const iconSmall = obj.iconSmall ? this.$utils.returnImgUrl(obj.iconSmall) : unSelectSrc;
      const map = {
        1: unSelectSrc,
        2: selectSrc,
        3: iconSmall,
      };
      return map[flag];
    },
    langName(obj = {}, field = "name") {
      return obj[field];
    },
    async handleSelect(key, i) {
      // 点击当前菜单
      // if (Number(key) === this.selectMenu) return;
      // console.log("======key, i=====", key, i);
      if (i === "menu") {
        let index = -1;
        this.pNavs.forEach((item, j) => {
          if (item.sid === key) {
            index = j;
          } else if (item.childMenu && item.childMenu.length) {
            const k = item.childMenu.findIndex((it) => it.sid === key);
            if (k > -1) {
              index = j;
            }
          }
        });
        if (index > -1) {
          this.currentIndex = index;
          this.anchorScroll();
        }
      } else {
        this.currentIndex = i;
        this.anchorScroll();
      }
      this.$set(this, "selectMenu", String(key));
      let flatList = [...this.pNavs];
      this.pNavs.map((item) => {
        if (item.childMenu && item.childMenu.length) {
          flatList = [...flatList, ...item.childMenu];
        }
      });
      const list =
        flatList.filter((v) => {
          return String(v.sid) === String(key);
        }) || [];
      this.curItem = list[0] || {};
      // console.log(key, keyPath, this.curItem);
      // 点击底部菜单展开收起一级菜单
      // if (!keyPath && this.curItem?.childMenu?.length) {
      //   const fun = this.openMenu[key] ? this.handleClose : this.handleOpen;
      //   if (this.openMenu[key]) {
      //     this.$refs.menu?.close(key);
      //   } else {
      //     this.$refs.menu?.open(key);
      //   }
      //   fun(key);
      //   return;
      // }

      console.log("this.curItem", this.curItem);
      // 数据埋点
      let enName = "";
      enName = this.curItem.language.name;
      // this.curItem.language?.map((v) => {
      //   if (v.language === "en") enName = v.name;
      // });
      const eventName = this.curItem.level === 1 ? "click_menu_first" : "click_menu_second";
      this.$eventPost(eventName, {
        menuId: this.curItem.sid,
        menuName: enName,
        enum: this.curItem?.jump?.functionType || "",
        jump_vlaue: this.curItem?.jump || {},
      });
      this.$eventPost("click", {
        eid: this.curItem.eid,
        time: Date.now(),
        menuId: this.curItem.sid,
        menuName: enName,
        enum: this.curItem?.jump?.functionType || "",
        jump_vlaue: this.curItem?.jump || {},
      });

      // if (this.getIsMobile && keyPath) {
      //   this.setMenuBar(false);
      // }

      if (this.curItem.jump.type === "Jump_TYPE_MULTIPLE_GAME") {
        // 多款游戏
        this.curItem["bindType"] = 1;
        localStorage.setItem("Cur_params", JSON.stringify(this.curItem));
        const { key, jumpName1, jumpName2 } = this.curItem?.jump?.multipleGame;
        if (jumpName1) {
          goJoinEvent(this.curItem.jump);
          return;
        } else if (key && this.cacheKeys.includes(key)) {
          // 缓存
          this.$router.push({ name: key + "1" }); // router和组件的name都在key的后面拼了1, +1才能匹配上
        } else {
          const flag = { flag: new Date().getTime() };
          this.$router.push({ name: "homeSearch", query: flag });
        }
      } else {
        // 其他
        goJoinEvent(this.curItem.jump);
      }
    },
    async getMenu() {
      this.pNavs = [];
      // 接口获取的pc菜单数据
      const { code, data } = await resMenuList({
        resType: this.getIsMobile ? "h5" : "pc",
      });
      if (code === 0) {
        const list = data.menuList || [];
        // this.h5ShowType = data.h5ShowType;
        const pcMenu = list;
        // 将菜单数据存到缓存
        localStorage.setItem("Pc_Menu_Info", JSON.stringify(pcMenu));
        // this.$Bus.$emit("footerMenu");
        // this.pNavs = [...this.pNavs, ...pcMenu];
        const navs = [...this.pNavs, ...pcMenu];
        navs.map((item, index) => {
          item.eid = `101_26_${index}_0`;
          if (item.childMenu && item.childMenu.length) {
            item.childMenu.map((it, i) => {
              it.eid = `101_26_${index}_${i + 1}`;
            });
          }
        });
        this.pNavs = navs;
      }
    },
    handleTopNav(item, eid) {
      this.$eventPost("click", {
        eid,
        time: Date.now(),
        jump_vlaue: item.jump,
      });
      goJoinEvent(item.jump);
    },
    // 点击气泡后不展示
    clickBubble() {
      this.$store.commit("setFirstWithdrawHint", { bubble: true });
    },
    // 首提
    getUserFirstWithdrawHintFun: debounce(async function (coinCode) {
      this.$store.dispatch("getUserFirstWithdrawHintAction", { coinCode });
    }, 100),
    clickSearch() {
      this.$eventPost("click", {
        eid: `101_0_0_128`,
        time: Date.now(),
      });
      this.$Bus.$emit("changeSearchDrawer");
    },
    handeleUserCoins() {
      const obj = this.getUserCoins;
      const data = { ...obj };
      const wallets = data.wallets || [];
      if (wallets.length === 0) {
        return false;
      }
      let UserCoins = [...wallets];
      UserCoins = UserCoins.map((v) => {
        // 充值 可提 彩金
        v.chips = this.divideAccuracy(
          Number(v.rechargeWallet) + Number(v.withdrawWallet) + Number(v.bonusWallet),
          v.accuracy
        );
        // 充值 可提 彩金 免费彩金
        v.allChips = this.divideAccuracy(
          Number(v.rechargeWallet) + Number(v.withdrawWallet) + Number(v.bonusWallet) + Number(v.experienceWallet),
          v.accuracy
        );
        v.isDefaultCoin = v.coinCode === this.defaultCoinCode; // 当前货币是否为会员货币
        // 体验彩金
        v.experience = this.hasExperienceWallet ? this.divideAccuracy(Number(v.experienceWallet), v.accuracy) : 0;
        // 佣金余额
        v.commission = Number(v.commissionWallet) ? this.divideAccuracy(Number(v.commissionWallet), v.accuracy) : 0;
        return { ...v };
      });
      const selectedCoinCode = data.selectedCoinCode || UserCoins[0]?.coinCode;

      this.$set(this, "UserCoins", UserCoins);
      if (!this.rateList.length) {
        this.getRateList(data);
      }
      this.afterGetCoincode(selectedCoinCode);
    },
    menuClick() {
      this.setMenuBar(!this.menuIsShow);
    },
    toLink(path) {
      // localStorage.setItem("after_quick", true);
      this.$router.push(path || "/");
    },
    // getTime() {
    //   // 美东 -4时间
    //   // const _this = this
    //   if (this.timer === null) {
    //     this.timer = setInterval(() => {
    //       this.bTime = [];
    //       this.curNum = this.curNum || 0;
    //       this.bTime.push({
    //         label: getAnyZoneTime(new Date().getTime(), -4).substring(11) + " (GMT-4:00)",
    //         value: 0,
    //       });
    //       this.bTime.push({
    //         label: getAnyZoneTime(new Date().getTime(), +8).substring(11) + " (GMT+8:00)",
    //         value: 1,
    //       });
    //     }, 1000);
    //   }
    // },
    triggerXiala() {
      this.$refs.timeSelect.focus();
    },

    async changeFun(val) {
      await clearAllDB();
      let code = 0;
      if (this.$store.getters.taken) {
        const res = (await updateUserLanguage({ language: val })) || {};
        code = res.code;
      }
      if (code === 0) {
        this.setLocale(val);
        this.$router.push("/home");
        // this.$Bus.$emit("reload")
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    },

    visibleChange(val) {
      if (val) {
        // console.log(val);
        const flag = localStorage.getItem("firstVisit");
        // console.log(flag, "flag");
        this.isFirst = !flag;
      }
      this.boxVisible = val;
    },
    async onShowInfoModal(type, walletTypeTxt) {
      this.infoType = type;
      this.walletTypeTxt = walletTypeTxt || 1
      this.PopupWindowShow = true;
    },
    getTitle() {
      if(this.infoType === 1) {
        return this.$t('Datalang.Wallet_BTM_switchwalletdescription')
      }
      if(this.infoType === 2) {
        return this.$t('Datalang.home_exprience')
      }
      if(this.infoType === 3) {
        return this.$t('Datalang.Recharge_TIP_tip')
      }
    },
    getTxt() {
      let walletTypeTxt = this.walletTypeTxt // 1真实钱包  2免费金币钱包  3佣金钱包
      return getTxtFun(walletTypeTxt)
    },
    goWithdraw(type){
      goWithdrawFun(type)
    },
    getBtnTxt() {
      return getBtnTxtFun()
    },
    goHandleChange(coinCode) {
      goHandleChangeFun(coinCode)
    },
    closeFun() {
      this.PopupWindowShow = false;
    },
    async getRateList(coinList = {}) {
      // 共用汇率loading，只请求一次汇率接口
      if (this.rateLoading) return;
      this.$store.commit("setRateLoading", true);
      const arr = coinList.wallets || [];
      const checkedCoin = arr.find((item) => item.coinCode === coinList.selectedCoinCode) || {};
      let dataList = [];
      if (this.coinExchangeRate.length) {
        dataList = this.coinExchangeRate;
      } else {
        const { code, data } = await getCoinExchangeRateData({});
        if (code === 0) {
          dataList = data.list || [];
          // 存汇率表
          this.$store.commit("setCoinExchangeRate", dataList);
        }
      }
      const walletCoin = arr.map((item) => item.coinCode) || [];
      const brr = dataList.filter((item) => item.toCoin === checkedCoin.coinCode) || [];
      const _arr = brr.filter((item) => walletCoin.includes(item.fromCoin)) || [];
      // 存当前货币汇率数据
      this.$store.commit("setRateList", _arr);
      this.$store.commit("setRateLoading", false);
    },

    // 前往钱包
    toWallet() {
      this.$router.push("/user/wallet");
    },
    goWalletDetail() {
      if (this.UserCoins?.length === 1) {
        this.$router.push("/user/wallet");
      }
    },
    afterGetCoincode(command) {
      // console.log("0803-afterGetCoincode", this.UserCoins, command);
      if (!command) return false;
      // const { code } = await this.killPlayerUser({});
      // if (code !== 0) {
      //   return;
      // }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === command;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", command);
      localStorage.setItem(
        "Cur_Chips",
        this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips
      );
      this.$store.commit("setSelectCoin", command);
    },
    handleHashChange({ tag }) {
      const path = `/search/all/all`;
      localStorage.setItem("curTag", JSON.stringify([tag]));
      const query = { flag: new Date().getTime() };
      this.$router.push({ path: path, query: query });
    },
    dropdown() {
      if (this.$refs.messageDrop.visible === true) {
        this.$refs.messageDrop.visible = false;
      } else {
        this.$eventPost("currency_display_click");
        this.$refs.messageDrop.visible = true;
      }
    },
    async handleCheck(val) {
      // this.handleCheckCoinCode(val);
      if (!val) return false;
      if (val.includes("experience")) return false;
      const { code } = await this.killPlayerUser({});
      if (code !== 0) {
        return;
      }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === val;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", val);
      localStorage.setItem(
        "Cur_Chips",
        this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips
      );
      this.$eventPost("click", {
        eid: `101_0_0_129`,
        coinCode: val,
        time: Date.now(),
      });
      selectWallet({ coinCode: val }).then((res) => {
        this.$store.commit("setSelectCoin", val);
        this.$store.dispatch("getUserInfo");
        if (isGame()) {
          // 在游戏中就刷新页面
          window.location.reload();
        }
        this.$Bus.$emit("reload");
      });
    },
    async handleCheckCoinCode(command, once = false) {
      if (!command) return false;
      // const { code } = await this.killPlayerUser({});
      // if (code !== 0) {
      //   return;
      // }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === command;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", command);
      localStorage.setItem(
        "Cur_Chips",
        this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips
      );
      await selectWallet({ coinCode: command }).then((res) => {
        this.$store.commit("setSelectCoin", command);
        if (!once) {
          if (isGame()) {
            // 在游戏中就刷新页面
            window.location.reload();
          }
        }
      });
    },
    // showWalletBalance() {
    //   this.$router.push("/user/wallet");
    // },
    handleCommand(data) {
      this.$eventPost("click", {
        eid: `101_0_0_133`,
        time: Date.now(),
        type: data.type,
        route: data.route,
      });
      const links = ["accountInfo", "promo", "router"];
      if (links.includes(data.type)) {
        this.$router.push(data.route);
      } else if (data.type === "Exchange") {
        // 兑换
        this.showExchange();
      } else if (data.type === "chargeExchange") {
        // 充值
        this.showCharge();
      } else {
        // console.log(this[data.type](data));
        // this[data.type](data);
        if (data.type === "signOut") {
          this.$store.dispatch("signOutPs");
          this.$message({
            message: this.$t("Datalang.Menu_BTM_logout"),
            type: "success",
            showClose: true,
          });
        }
      }
    },
    showCharge() {
      this.$eventPost("click", {
        eid: `101_0_0_130`,
        time: Date.now(),
      });
      this.$Bus.$emit("showCharge", { show: true });
    },
    showExchange() {
      this.$eventPost("click", {
        eid: `101_0_0_131`,
        time: Date.now(),
      });
      this.$Bus.$emit("showExchange", { show: true });
    },
    clickFun(type, eid) {
      const objStr = {
        0: "Login",
        1: "Register",
      };
      this.$eventPost("click", {
        eid,
        time: Date.now(),
      });
      this.$Bus.$emit("showLogin", { show: true, tab: objStr[type] });
    },
    ...mapActions(["signOutPs", "setMenuBar"]),
    chargeExchange(data) {
      this.$isPopShow({
        show: true,
        views: data.route,
        data: {
          title: data.title,
        },
      });
    },
    anchorScroll() {
      this.$nextTick(() => {
        console.log(this.currentIndex, "this.currentIndex");
        const menuItem = this.$refs.menuItem[this.currentIndex];
        if (menuItem) {
          // const scrollWrapper = menuItem.closest(".tab-center");
          const scrollWrapper = this.$refs.menuWrap;
          console.log("scrollWrapper", scrollWrapper);
          if (scrollWrapper) {
            const itemRect = menuItem?.getBoundingClientRect();
            const wrapperRect = scrollWrapper?.getBoundingClientRect();
            // console.log(
            //   itemRect.left,
            //   itemRect.width,
            //   wrapperRect.left,
            //   wrapperRect.width
            // );
            // 计算需要滚动的位置，使当前项居中
            const scrollLeft = itemRect.left - wrapperRect.left - wrapperRect.width / 2 + itemRect.width / 2;
            // console.log("scrollLeft", scrollLeft, scrollWrapper.scrollLeft, scrollWrapper.scrollLeft + scrollLeft);
            scrollWrapper.scrollTo({
              left: scrollWrapper.scrollLeft + scrollLeft,
              behavior: "smooth",
            });
          }
        }
      });
    },
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  activated() {},
};
</script>
<style>
.search-icon {
  width: 36px;
  height: 36px;
  margin: 0 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--button-1100);
  border-radius: var(--radius-200);
  transition: background 0.3s ease;
  &:hover {
    background: var(--button-1101);
  }
  img {
    width: 20px;
    height: 20px;
  }
}
.lang .el-input__inner {
  width: 130px;
  border-radius: 14px;
  padding-left: 30px;
}
</style>
<style lang="scss" scoped>
//body.black-theme .el-dropdown-menu.el-popper {
// max-height: 500px;
// overflow: auto;
//}
::v-deep .el-avatar {
  cursor: pointer;
  border: 1px solid var(--border-color-100) !important;
}
.flex-box {
  display: flex;
  align-items: center;

  &.right {
    justify-content: flex-end;
  }
}

.cur-lang-icon-new {
  width: 30px;
  height: 30px;
  display: block;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  cursor: pointer;
}

.lang-row-wrap {
  display: flex;
  align-items: center;

  .language-icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
}

.lang {
  position: relative;

  .cur-lang-icon {
    position: absolute;
    width: 20px;
    left: 6px;
    top: 16px;
    z-index: 1;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    box-shadow: 0px 3px 5px 0px #ddd;
  }

  :deep(.el-select) {
    .el-input .el-select__caret {
      // background: url("~@/assets/new/xiala_btn.png") no-repeat;
      transform: rotateZ(0deg);
      appearance: none;
      background-size: 15px 8px;
      width: 15px;
      height: 8px;
      position: absolute;
      top: 24px;
      right: 3px;
    }

    .el-icon-arrow-up:before {
      content: "";
    }
  }
}

.lgoin-button {
  text-align: center;
  height: 36px;
  min-width: 110px;
  padding: 0 10px;
  box-sizing: border-box;
  &:hover {
    opacity: 0.8;
  }
  &:nth-child(1) {
    height: 36px;
    min-width: 110px;
    padding: 0 10px;
    color: var(--font-color-1401);
    border-color: transparent;
    //  @include buttonPrimary;
  }

  &:nth-child(2) {
    height: 36px;
    min-width: 110px;
    padding: 0 10px;
    @include buttonPrimary;
    font-weight: 600;
    &:hover {
      background: var(--button-101);
    }
  }
}
.p-header .lgoin-button1 {
  border-color: var(--font-color-300);
}

.p-header .recharge {
  height: 36px;
  min-width: 90px;
  padding: 0 10px;
  @include buttonPrimary;
}

.p-header .withdraw {
  position: relative;
  height: 36px;
  min-width: 90px;
  padding: 0 10px;
  @include buttonYellow;
  .firstWithdrawTis-wrap {
    position: absolute;
    top: 42px;
    left: 0;
    width: 220px;
    font-size: 14px;
    line-height: 18px;
    padding: 5px 10px;
    box-sizing: border-box;
    color: var(--font-color-200);
    z-index: 9;
    .triangle {
      display: block;
      position: absolute;
      top: -6px;
      left: 50px;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid var(--background-1400);
      opacity: 0.8;
    }
    .text1 {
      width: 100%;
      position: relative;
      z-index: 1;
      text-wrap: wrap;
      word-break: break-word;
    }
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--background-1400);
      opacity: 0.8;
      border-radius: 10px;
    }
  }
}

.modal-info {
  word-break: break-word;

  div {
    line-height: 24px;
  }

  .btn-content {
    display: flex;
    justify-content: center;
  }
}

.wallet_list_header {
  top: 60px !important;
  max-height: 70vh;
  overflow-y: auto;

  .is-disabled {
    color: var(--font-color-300);
    pointer-events: auto;
  }
}

.el-dropdown-menu.el-popper {
  padding: 10px;

  .qbHeaer,
  .qbFooter {
    cursor: auto;

    .el-icon-question {
      cursor: pointer;
      margin-left: 5px;
    }
  }

  .qbHeaer {
    padding: 0 10px;
    margin: 0 10px;
    &:hover {
      background: transparent !important;
      color: var(--font-color-100);
    }
  }

  .qbItem {
    margin-bottom: 2px;
    border-radius: 3px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -o-border-radius: 3px;
    padding: 0 10px;
    margin: 0 10px;
  }

  .is-disabled {
    color: var(--font-color-300) !important;
  }

  .qbFooter {
    text-align: center;
    height: 36px;
    padding: 8px 0;

    .walletBtn {
      cursor: pointer;
      line-height: 24px;
      padding: 6px 20px;
      display: inline-block;
      overflow: hidden;
      position: relative;
      @include buttonPrimary;

      &.first {
        &:before {
          content: "";
          position: absolute;
          width: 200px;
          height: 30px;
          /**白光的宽度，可根据实际调整**/
          background-image: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.5), transparent);
          -webkit-transform: rotate(-45deg);
          -moz-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          -o-transform: rotate(-45deg);
          transform: rotate(-45deg);
          -webkit-animation: searchLights 3s ease-in 1s infinite;
          -o-animation: searchLights 3s ease-in 1s infinite;
          animation: searchLights 3s ease-in 1s infinite;
          /**第一个数字参数控制扫光速度，数字越大越慢**/
        }

        @keyframes searchLights {
          0% {
            left: -120px;
            top: -20px;
          }

          100% {
            left: 100px;
            top: 100px;
          }
        }
      }
    }

    .disable_btn {
      background: #ccc;
      cursor: not-allowed;
    }
    &:hover {
      background: transparent !important;
    }
  }
}

.qbDiv {
  position: relative;
  padding: 0 140px 0 25px;
  &.experienceWrap {
    margin-bottom: 20px;
  }
  .experience_coin {
    line-height: 1;
    font-size: 12px;
    color: var(--font-color-1800);
    .el-icon-question {
      pointer-events: all;
      cursor: pointer;
      margin-left: 5px;
      font-size: 14px;
      color: var(--font-color-200);
    }
  }

  img {
    position: absolute;
    width: 16px;
    height: 16px;
    left: 0;
    top: 8.5px;
  }

  .chips {
    position: absolute;
    width: 140px;
    right: 0;
    top: 0;
    text-align: right;
  }
}

.symbol_coin {
  line-height: 36px;
  // padding-left: 35px;
}

.symbol_coin.symbol_coin1 {
  position: relative;
  line-height: 18px;

  .symbol_span {
    // position: absolute;
    left: 0;
    top: 0;
    width: 30px;
    text-align: right;
    padding-right: 5px;
  }
}

.sports-list {
  background-color: transparent !important;
  border: none;
  box-shadow: none;

  .icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .el-dropdown-menu__item {
    border-radius: 10px;
    margin-top: 3px;
    display: flex;
    align-items: center;

    // &:hover {
    //   .icon-ag {
    //     background: url("~@/assets/img/head/icon_ag_xz.png");
    //   }

    //   .icon-bti {
    //     background: url("~@/assets/img/head/icon_bti_xz.png");
    //     background-repeat: no-repeat;
    //     width: 30px;
    //     height: 30px;
    //     display: inline-block;
    //     background-size: contain;
    //     margin-right: 10px;
    //     background-position: center;
    //   }
    // }

    // .icon-ag {
    //   background: url("~@/assets/img/head/icon_ag.png");
    //   background-repeat: no-repeat;
    //   width: 16px;
    //   height: 16px;
    //   display: inline-block;
    //   background-size: contain;
    //   width: 36px;
    //   height: 20px;
    //   margin-right: 10px;
    // }

    // .icon-bti {
    //   background: url("~@/assets/img/head/icon_bti.png");
    //   background-repeat: no-repeat;
    //   width: 30px;
    //   height: 30px;
    //   display: inline-block;
    //   background-size: contain;
    //   margin-right: 10px;
    //   background-position: center;
    // }
  }
}

.login-btn {
  text-align: right;
  display: flex;
  align-items: center;
}

.box-flex {
  display: flex;
  text-align: center;
  justify-content: flex-end;
  align-items: center;
}

.head-user-info {
  ::v-deep .el-avatar {
    background-color: transparent;
    cursor: pointer;
    overflow: hidden;
    > img {
      transition: transform linear 0.3s;
    }
    &:hover > img {
      transform: scale(1.2);
    }
  }

  .vip-box {
    margin-right: 16px;
    font-size: 14px;
    color: var(--font-color-100);
  }

  .chips-box {
    max-width: 160px;
    margin: 0 12px;
    height: 32px;
    padding: 4px 8px;
    line-height: 22px;
    font-size: 14px;
    text-align: left;
    background: var(--background-900);
    border-color: var(--background-900);
    color: var(--font-color-100);

    .chips-num {
      color: var(--font-color-100);
    }
  }
}

.badge-item {
  ::v-deep .el-badge__content {
    border: none;
  }
}

.dropdown-box {
  ::v-deep .popper__arrow {
    &::after {
      border-bottom-color: var(--background-800);
    }
  }

  .el-dropdown-menu__item {
    min-width: 140px;
    max-width: 300px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 3px;
    padding: 5px 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    .icon {
      width: 20px;
      height: 20px;
      vertical-align: unset;
    }

    .title {
      margin-left: 20px;
    }

    // &:hover {
    //   background-color: var(--background-1400) !important;
    //   color: var(--font-color-100);
    // }
  }
}

.Casino,
.Sports {
  display: block;
  float: left;
  height: 32px;
  line-height: 32px;
  padding: 3px 12px;
  z-index: 3;
  border-radius: 30px;
  color: var(--font-color-100);
  margin: 0 5px;

  &.active {
    background: var(--background-600);
  }
}

.Casino:hover,
.Sports:hover {
  display: block;
  float: left;
  height: 32px;
  line-height: 32px;
  padding: 3px 12px;
  z-index: 3;
  border-radius: 30px;
  background: var(--background-600);
}

.Casino img {
  width: 26px;
  height: 22px;
  margin: 3px 0;
  float: left;
}

.Sports img {
  width: 24px;
  height: 24px;
  margin: 4px 0;
  float: left;
}

.Casino em,
.Sports em {
  float: right;
  margin-left: 12px;
  font-size: 14px;
}

.Casino:hover img {
  width: 26px;
  height: 22px;
  margin: 3px 0;
  float: left;
  animation: Casino 4s linear infinite;
}

.Sports:hover img {
  width: 24px;
  height: 24px;
  margin: 4px 0;
  float: left;
  animation: Sports 4s linear infinite;
}

// .coin-img {
//   width: 30px;
//   height: 30px;
//   border-radius: 50%;
//   background: #ccc;
// }

.Casino:hover em,
.Sports:hover em {
  float: right;
  margin-left: 12px;
  font-size: 14px;
  color: var(--font-color-100);
}

.transition {
  transition: 0.5s;
  -ms-transition: 0.5s;
  -moz-transition: 0.5s;
  -webkit-transition: 0.5s;
}

@keyframes Casino {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes Sports {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}
.flex {
  display: flex;
  align-items: center;
  height: 20px;
}
.qbMode {
  background: var(--pulldown-100) !important;
  padding: 0 !important;
  .qbModeMain {
    min-width: 300px;
    .qbModeMainTop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      line-height: 30px;
      font-size: 13px;
      background: var(--background-400);
      padding: 0 10px;
      border-radius: 5px 5px 0 0;
    }
    .qbModeMainCon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      padding: 10px;
      box-sizing: border-box;
      background: var(--background-1502);
      border-radius: 0 0 5px 5px;
      .amount{
        font-size: 16px;
      }
      .qbModeMainConRight{
        display: flex;
        align-items: center;
        .btn {
          font-size: 12px;
          cursor: pointer;
          line-height: 24px;
          padding: 3px 10px;
          display: inline-block;
          overflow: hidden;
          position: relative;
          @include buttonPrimary;
        }
      }
    }
  }
}
.godVip-box {
  // margin-left: 18px;
  .el-dropdown-link {
    display: flex;
    justify-content: space-around;
    align-items: center;
    min-width: 120px;
    height: 36px;
    line-height: 36px;
    padding: 8px;
    border-radius: var(--radius-200);
    color: var(--font-color-200);
    background: var(--background-700);
    cursor: pointer;
    box-sizing: border-box;
    &.el-dropdown-link1 {
      height: 46px;
      line-height: 20px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
    img {
      width: 22px;
      height: 22px;
      margin-right: 4px;
    }
  }
}

.p-header {
  color: var(--font-color-200);
  margin: 0 auto;

  .top-nav-wrap {
    padding: 0 15px;
    height: 60px;
    display: flex;
    align-items: center;
    background: var(--background-201);
    box-shadow: var(--boxShadow-700);

    .topnav {
      padding-right: 60px;
      display: flex;
      align-items: center;
      &-item {
        position: relative;
        padding: 0 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: var(--font-color-100);
        font-size: 14px;
        &:hover {
          opacity: 0.8;
        }
        &::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          border-right: 1px solid var(--font-color-700);
          height: 80%;
        }
        &:last-child::after {
          display: none;
        }
        &-icon {
          width: 20px;
          height: 20px;
          padding-right: 10px;
        }
      }
    }
  }

  .menu-icon {
    width: 35px;
    height: 35px;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    &.left {
      margin-right: 15px;
    }
    &.right {
      margin-left: 10px;
    }
    &.show-menu {
      img {
        transform: rotate(0);
      }
    }

    img {
      transition: transform ease 0.5s;
      transform-origin: center;
      display: block;
      width: 26px;
      transform: rotate(-180deg);
    }
  }

  .logo-box {
    justify-content: flex-start;

    .logo {
      height: 40px;
      cursor: pointer;
    }

    .collapse-on-off {
      font-size: 28px;
      margin: 0 12px 0 6px;
      cursor: pointer;
      z-index: 9;
    }

    .mainNav {
      display: flex;
    }
  }
  .right-wrap {
    display: flex;
    flex: 1;
    max-width: 1340px;
    height: 100%;
    justify-content: space-between;
    margin: 0 auto;
    padding: 0 35px;
    box-sizing: border-box;
    .action-wrap {
      display: flex;
      align-items: center;
      .user-wrap {
        margin-left: 30px;
        display: flex;
        align-items: center;
        min-width: 120px;
      }
    }
  }
}

.el-menu-item:hover,
.el-menu-item:focus {
  background-color: unset;
}
.nav-menu-list {
  width: 100%;
}
.menu-inner {
  // overflow: hidden;
  overflow-y: auto;
  &.grid-box {
    display: flex;
    align-items: center;
  }
  &.imageList {
    display: flex;
    align-items: center;

    // flex-wrap: wrap;
    height: 45px;
    .menu-mask {
      position: fixed;
      top: 140px;
      left: 0;
      right: 0;
      bottom: 0;
      transition: all 0.45s ease-in-out;
      background: rgba(0, 0, 0, 0.5);
      z-index: -1;
      opacity: 0;
      height: 0;
      visibility: hidden;
      &.isInTelegramWebApp {
        top: calc(140px + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px));
      }
      &.show {
        opacity: 0.5;
        visibility: visible;
        height: unset;
      }
    }
    .menu-item {
      flex-shrink: 0;
      position: relative;
      height: 100%;
      padding: 0 15px;
      line-height: 45px;
      // max-width: 150px;
      overflow: hidden;
      cursor: pointer;
      color: var(--font-color-200);
      transition: color ease 0.3s;
      &.is-active,
      &:hover {
        color: var(--font-color-200);
        background: var(--background-800);
      }
      &:hover .menu-item-sub {
        opacity: 1;
        visibility: visible;
        height: unset;
      }
      &-sub {
        position: fixed;
        top: 105px;
        left: 0;
        width: 100%;
        display: block;
        transition: all 0.4s ease-in-out;
        opacity: 0;
        height: 0;
        visibility: hidden;
        &.isInTelegramWebApp {
          top: calc(140px + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px));
        }
        .sub-item {
          position: relative;
          margin-right: 20px;
          margin-bottom: 10px;
          width: calc((100% - 200px) / 6);
          max-width: 200px;
          padding: 10px;
          box-sizing: border-box;
          border-radius: var(--radius-100);
          transition: all 0.3s ease-in-out;
          &:nth-of-type(6n) {
            margin-right: 0;
          }
          &:hover {
            background: var(--background-1502);
          }
          &_thumb {
            width: 100%;
            border-radius: 10px;
          }
          &_play {
            margin-top: -10px;
            display: flex;
            justify-content: center;
            align-items: center;
            .btn {
              @include buttonPrimary;
            }
          }
          &-icon {
            width: 100%;
          }
        }
      }
      &-wrap-bg {
        position: relative;
        background: var(--background-1501);
      }
      &-wrap {
        margin: 0 auto;
        display: flex;
        align-content: center;
        box-sizing: border-box;
        padding: 20px 25px 20px 25px;
        max-width: 1340px;
        flex-wrap: wrap;
      }
    }
  }
}
ul.el-menu--horizontal .el-menu-item {
  margin: 0;
  padding: 0 20px;
}
::v-deep .el-submenu__icon-arrow {
  display: none;
}
::v-deep .el-menu--horizontal .el-menu-item {
  min-height: 45px;
  height: 45px;
  line-height: 45px;
  border-radius: 0;
  overflow: hidden;
  font-weight: 600;
  // max-width: 160px;

  .el-submenu__icon-arrow {
    display: none;
  }

  &.is-active,
  &:hover {
    color: var(--font-color-200);
    background: var(--background-800);
  }
  &:focus {
    color: inherit;
  }
  .unselected {
    display: block;
  }
  .selected {
    display: none;
  }
  .iconSmall {
    display: none;
  }
  .nav-icon-wrap.active {
    .unselected {
      display: none;
    }
    .selected {
      display: block;
    }
  }
  .name {
    transition: color ease 0.3s;
  }
  &:hover {
    .name {
      color: var(--font-color-200);
    }
    .unselected {
      display: none;
    }
    .selected {
      display: block;
    }
  }
}
::v-deep .el-menu--horizontal .el-submenu__title {
  min-height: 45px;
  height: 45px;
  line-height: 45px;
  border-radius: 0;
  overflow: hidden;
  max-width: 160px;
  font-weight: 600;
  font-size: inherit;
  transition: color ease 0.3s;

  .unselected {
    display: block;
  }
  .selected {
    display: none;
  }
  .iconSmall {
    display: none;
  }
  .nav-icon-wrap.active {
    .unselected {
      display: none;
    }
    .selected {
      display: block;
    }
  }
  .name {
    transition: color ease 0.3s;
  }
  &:hover {
    background: var(--background-800);
    .name {
      color: var(--font-color-200);
    }
    .unselected {
      display: none;
    }
    .selected {
      display: block;
    }
  }
}

.p-header {
  .menu-main {
    position: relative;
    height: 45px;
    background: var(--background-202);
    box-shadow: var(--boxShadow-700);
  }
  .menu-wrap {
    max-width: 1340px;
    margin: 0 auto;
    padding-left: 35px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    .menu-inner {
      // margin-left: 35px;
      flex: 1;
      border: none;
      .el-submenu__title {
        height: 45px;
        line-height: 45px;
      }
    }
    .nav-icon-wrap {
      display: flex;
      align-items: center;
    }
    .nav-icon {
      margin-right: 5px;
      width: 24px;
      height: 24px;
    }
  }
}

.nav-icon-wrap {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  position: relative;

  .unselected {
    display: block;
  }
  .selected {
    display: none;
  }
  .iconSmall {
    display: none;
  }

  &.iconType2 {
    // 做背景
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin-right: 0;
    .iconSmall {
      width: 16px;
      height: 16px;
      margin: 0 auto;
    }
  }
  .nav-icon {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.el-menu-item:hover .unselected {
  display: none;
}
.el-menu-item:hover .selected {
  display: block;
}
.el-menu-item:hover .iconSmall {
  display: none;
}

::v-deep .changeTime.el-select .el-input__inner {
  background: none;
  color: var(--font-color-100);
  border: none;
}

::v-deep .changeTime.el-select .el-input__icon::before {
  content: "";
}

.xiala {
  left: 165px;
  cursor: pointer;
}

.account_info {
  line-height: 18px;
  font-size: 12px;
  margin-left: 5px;
  display: flex;
  align-items: center;
  &-name {
    padding: 0 10px;
    position: relative;
    color: var(--font-color-100);
    &::after {
      position: absolute;
      content: "";
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 80%;
      border-right: 1px solid var(--border-color-300);
    }
  }

  .account_vip {
    position: relative;
    width: 40px;
    margin-left: 15px;
    padding-left: 18px;
    height: 18px;
    line-height: 18px;
    border-radius: 9px;
    background: var(--background-700);
    color: var(--font-color-900);

    .p_vip {
      position: absolute;
      left: -6px;
      top: -1px;
      width: 24px;
    }
  }
}

.el-select-dropdown__item {
  display: flex;

  .language-icon {
    height: 24px;
    margin-top: 5px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    box-shadow: 0px 3px 5px 0px #ddd;
  }

  .language-title {
    margin-left: 10px;
  }
}
.redPoint {
  background-color: var(--tips-100);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  right: 8px;
  top: 10px;
  z-index: 9;
}
.redPoint:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  margin-top: -4px;
  margin-left: -4px;
  background-color: var(--tips-100);
  -webkit-animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes ping {
  75% {
    -webkit-transform: scale(2.5);
    -ms-transform: scale(2.5);
    transform: scale(2.5);
    opacity: 0.4;
  }
  100% {
    -webkit-transform: scale(2.5);
    -ms-transform: scale(2.5);
    transform: scale(2.5);
    opacity: 0;
  }
}
.experienceDiv {
  padding-left: 25px;
  padding-bottom: 5px;
}
#vStep {
  position: relative; /* 作为定位基准 */
  display: inline-block;
}

.dropdown-tip {
  position: absolute;
  top: 100%;            /* 紧贴 dropdown 底部 */
  left: 50%;            /* 水平居中 */
  transform: translateX(-50%);
  margin-top: 16px;
  padding: 4px 10px;
  background: var(--background-500);
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
}

.dropdown-tip-arrow {
  position: absolute;
  top: -6px;            /* 箭头顶到提示框 */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--background-500);
}
</style>
<style lang="scss">
.el-menu--horizontal .el-menu.el-menu--popup {
  padding: 15px 0 10px 0;
  background: var(--pulldown-100);
  & > .grid-box > .el-menu-item {
    height: 44px;
    line-height: 44px;
    background: transparent;
    // color: var(--font-color-500);
    &:hover {
      background: var(--background-1400);
      color: var(--font-color-200);
    }
    &.is-active {
      background: var(--background-1400);
      color: var(--font-color-200);
    }
  }
}
</style>
